package com.milta.feature.route.domain.usecase

import com.milta.feature.route.domain.entity.TeamRoutesOverview
import com.milta.feature.route.domain.repository.RouteRepository

/** GET /api/v1/routes — Manager team dashboard for a given day, defaults to today (MIL-38). */
class GetTeamRoutesOverviewUseCase(private val repository: RouteRepository) {
    suspend operator fun invoke(date: String? = null): TeamRoutesOverview = repository.getTeamRoutesOverview(date)
}
